import React, { useEffect } from "react";

const Error401 = () => {
    const clearLocalStorage = () =>{
        localStorage.clear()
    }
    useEffect(() => {
      const timeoutId = setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 5000);
    
      return () => clearTimeout(timeoutId); // Cleanup on unmount
    }, []);
  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          style={{
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            height: "100%",
            display: "grid",
            fontSize: "30px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              display: "grid",
              alignItems: "center",
              alignContent: "center",
              height: "100%",
            }}
          >
            <h1 class="w3-jumbo w3-animate-top w3-center">
              <code>Your Session Timeout</code>
            </h1>
            <h4 class="w3-center w3-animate-right">
                Please Re <a onClick={clearLocalStorage} href="/">log in </a> again to continue. If the issue persists, contact the support team. 
            </h4>
            <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
            <h6 class="w3-center w3-animate-zoom">
              error code:401 Access Token Expired 
            </h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error401;
